// extracted by mini-css-extract-plugin
export default {"slideContainer":"_5499d05b5e _59ea36b033 f112112130","slideImage":"_84388a5369"};